// File: src/App.js
import React, { useEffect } from 'react';
import { DataContext, DataContextProvider } from './contexts/DataContext';
import { DataContext2, DataContext2Provider } from './contexts/DataContext2';
import { DataContext3, DataContext3Provider } from './contexts/DataContext3';
import { DataContext4, DataContext4Provider } from './contexts/DataContext4';

import LandingPage from './pages/LandingPage';
import './config/i18n';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RegistrationPage from './pages/RegistrationPage';
import RegistrationPage2 from './pages/RegistrationPage2';
import RegistrationPage3 from './pages/RegistrationPage3';
import RegistrationPage4 from './pages/RegistrationPage4';

import { useTranslation } from 'react-i18next';
import AgeConfirmationDialog from './components/AgeOnboarding';
import TermsPage from './pages/TermsPage';
import LandingPage2 from './pages/LandingPage2';
import LandingPage3 from './pages/LandingPage3';
import LandingPage4 from './pages/LandingPage4';
import { FlowProvider } from './contexts/FlowContext';
import { DataContext1, DataContext1Provider } from './contexts/DataContext1';

function App() {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (!['de', 'en', 'fr']?.includes(localStorage.getItem('i18nextLng')))
      i18n.changeLanguage('en');
  }, [i18n]);

  return (
    <FlowProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/2/*"
            element={
              <DataContext2Provider>
                <DataContextProvider>
                  <>
                    <AgeConfirmationDialog context={DataContext2} />
                    <Routes>
                      <Route
                        path="registration"
                        element={<RegistrationPage2 />}
                      />
                      <Route path="terms" element={<TermsPage />} />
                      <Route path="*" element={<LandingPage2 />} />
                    </Routes>
                  </>
                </DataContextProvider>
              </DataContext2Provider>
            }
          />
          <Route
            path="/3/*"
            element={
              <DataContext3Provider>
                <DataContextProvider>
                  <>
                    <AgeConfirmationDialog context={DataContext3} />
                    <Routes>
                      <Route
                        path="registration"
                        element={<RegistrationPage3 />}
                      />
                      <Route path="terms" element={<TermsPage />} />
                      <Route path="*" element={<LandingPage3 />} />
                    </Routes>
                  </>
                </DataContextProvider>
              </DataContext3Provider>
            }
          />
          <Route
            path="/*"
            element={
              <DataContext1Provider>
                <DataContextProvider>
                  <>
                    <AgeConfirmationDialog context={DataContext1} />
                    <Routes>
                      <Route
                        path="registration"
                        element={<RegistrationPage />}
                      />
                      <Route path="terms" element={<TermsPage />} />
                      <Route path="*" element={<LandingPage />} />
                    </Routes>
                  </>
                </DataContextProvider>
              </DataContext1Provider>
            }
          />
        </Routes>
      </BrowserRouter>{' '}
    </FlowProvider>
  );
}

export default App;
